/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getTenantData, updateTenantData } from '../services/tenant';
import { setLocation, setTenant, showToast } from '../redux/auth/auth.action';
import { setCallPercentage } from '../redux/phone-percentage/percentage.action';
import swal from 'sweetalert';
import { APP_VERSION, BUILD_DATE_TIMESTAMP } from '../helper/constant';

import SwitchServer from 'container/SwitchServer';
import FooterEnd from 'comman/component/footerEnd';

const Settings = ({
  tenantId,
  setTenant,
  tenant,
  user,
  totalPercentage,
  setCallPercentage,
  setLocation,
}) => {
  const [buttonEvent, setButtonEvent] = useState(false);
  const [androidPercentage, setAndroidPercentage] = useState(
    totalPercentage.android
  );
  const [iosPercentage, setIosPercentage] = useState(totalPercentage.ios);
  const [errorMessage, setErrorMessage] = useState(null);
  const [initialValues, setIntialValues] = useState({
    name: '',
    email: '',
    number: '',
    fbToken: '',
  });

  useEffect(() => {
    if (tenantId) {
      (async () => {
        const response = await getTenantData(tenantId);
        await setTenant(response.data);
        if (response.status === 200) {
          setIntialValues((prevState) => ({
            ...prevState,
            name: response.data.name,
            email: response.data.email,
            fbToken: response.data.firebaseToken,
          }));
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  // useEffect(() => {
  //   if (!iosPercentage || !androidPercentage) {
  //     setErrorMessage('Please enter number');
  //     return;
  //   }
  //   if (iosPercentage && isNaN(iosPercentage)) {
  //     setErrorMessage('Please enter number');
  //     return;
  //   }
  //   if (androidPercentage && isNaN(androidPercentage)) {
  //     setErrorMessage('Please enter number');
  //     return;
  //   }
  //   if (
  //     androidPercentage &&
  //     iosPercentage &&
  //     +androidPercentage + +iosPercentage !== 100
  //   ) {
  //     setErrorMessage('Total Percentage must be equal to 100');
  //     return;
  //   } else {
  //     setErrorMessage(null);
  //     setCallPercentage({
  //       ios: iosPercentage,
  //       android: androidPercentage,
  //     });
  //     return;
  //   }
  // }, [androidPercentage, iosPercentage]);

  const handlePhonePercentages = () => {
    if (!iosPercentage || !androidPercentage) {
      setErrorMessage('Fields are required');
      return;
    }
    if (iosPercentage && isNaN(iosPercentage)) {
      setErrorMessage('Please enter number');
      return;
    }
    if (androidPercentage && isNaN(androidPercentage)) {
      setErrorMessage('Please enter number');
      return;
    }
    if (
      androidPercentage &&
      iosPercentage &&
      +androidPercentage + +iosPercentage !== 100
    ) {
      setErrorMessage('Total Percentage must be equal to 100');
      return;
    } else {
      setErrorMessage(null);
      totalPercentage.ios !== iosPercentage &&
        totalPercentage.android !== androidPercentage &&
        setCallPercentage({
          ios: iosPercentage,
          android: androidPercentage,
        });
      return;
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    fbToken: Yup.string().required('Token is required'),
  });

  const submitFunction = async (value) => {
    try {
      const wrapper = document.createElement('div');
      wrapper.innerHTML =
        "<p className='swal-text-data'>Are you sure you want to update?</p>";

      await swal({
        title: 'Update Confirmation',
        content: wrapper,
        className: 'swal-md',
        loading: true,
        buttons: {
          confirm: {
            width: 30,
            text: 'Confirm',
            value: 'confirm',
            visible: true,
            className: 'swal-primary-button',
            closeModal: false,
          },
          cancel: {
            width: 15,
            text: 'Cancel',
            value: 'cancel',
            visible: true,
            className: 'swal-default-button',
            closeModal: true,
          },
        },
      }).then(async (valueSwal) => {
        if (valueSwal === 'confirm') {
          setButtonEvent(true);
          const data = {
            localizations: {
              name: {
                en: {
                  language: 'en',
                  value: value.name,
                },
              },
            },
            firebaseToken: value.fbToken,
            email: value.email,
          };

          const res = await updateTenantData(tenantId, data);
          if (res.status === 200) {
            setTenant(res.data);
          }
          swal.close();
        }
      });
    } catch (error) {
      showToast({
        show: false,
        message: error,
      });
    } finally {
      setButtonEvent(false);
    }
  };

  return (
    <div id='pageWrapper'>
      <div className='main-page'>
        <div className='page-wrapper'>
          <section className='common-sec setting-sec'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-12 col-md-12 col-lg-8 left-clm'>
                  <div className='card'>
                    <div className='card-header'>
                      <h2>Tenant Information</h2>
                    </div>
                    <div className='card-body '>
                      <div className='setting-form-wrapper row'>
                        <div className='col-12 col-md-12 col-lg-6'>
                          <Formik
                            enableReinitialize={true}
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={(value) => submitFunction(value)}>
                            {({ values, errors, isValid, dirty }) => (
                              <Form>
                                <div className='user-form'>
                                  <div className='form-group'>
                                    <Field
                                      type='text'
                                      name='name'
                                      className='form-control form-control-sm'
                                      placeholder='Company Name'
                                    />
                                    <ErrorMessage name='name'>
                                      {(msg) => (
                                        <span
                                          className='fm_error'
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                  <div className='form-group'>
                                    <Field
                                      type='email'
                                      name='email'
                                      className='form-control form-control-sm'
                                      placeholder='Company Address'
                                    />
                                    <ErrorMessage name='email'>
                                      {(msg) => (
                                        <span
                                          className='fm_error'
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                  <div className='form-group'>
                                    <Field
                                      type='text'
                                      name='fbToken'
                                      className='form-control form-control-sm'
                                      placeholder='Firebase Token'
                                    />
                                    <ErrorMessage name='fbToken'>
                                      {(msg) => (
                                        <span
                                          className='fm_error'
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                  {/* <div className='form-group'>
                                    <Field
                                      type='number'
                                      name='number'
                                      className='form-control form-control-sm'
                                      placeholder='Company Number'
                                    />
                                    <ErrorMessage name='number'>
                                      {(msg) => (
                                        <span
                                          className='fm_error'
                                          style={{ color: 'red' }}
                                        >
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div> */}
                                  <div className='button-wrap'>
                                    <button
                                      className='btn btn-primary'
                                      type='submit'>
                                      Save
                                    </button>
                                    {/* {dirty && (
                                      <button
                                        type='reset'
                                        className='btn btn btn-light ms-2'>
                                        Refresh
                                      </button>
                                    )} */}
                                  </div>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-md-12 col-lg-4 right-clm'>
                  <div className='card settings-account-details mb-3'>
                    <div className='card-header'>
                      <h2>Smartphone App Percentages</h2>
                    </div>
                    {/* <div className='card-body'>
                      <div className='settings-list-wrapper'>
                        <ul>
                          <li>
                            <label htmlFor=''>Contact Email</label>{' '}
                            <span>{user.username}</span>
                          </li>
                          <li>
                            <label htmlFor=''>Account Role(s)</label>
                            <span>-</span>
                          </li>
                          <li>
                            <label htmlFor=''>Payment Method</label>
                            <span>-</span>
                          </li>
                          <li>
                            <label htmlFor=''>Account Currency</label>
                            <span>-</span>
                          </li>
                          <li>
                            <label htmlFor=''>Account Timezone</label>
                            <span>{tenant.timezone}</span>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                    <div className='card-body'>
                      <div className='settings-list-wrapper'>
                        <ul>
                          <li style={{ display: 'flex' }}>
                            <label htmlFor=''>Android Users</label>
                            <input
                              type='text'
                              onChange={(e) =>
                                setAndroidPercentage(e.target.value)
                              }
                              defaultValue={
                                totalPercentage.android &&
                                totalPercentage.android
                              }
                            />
                          </li>
                          <li style={{ display: 'flex' }}>
                            <label htmlFor=''>iOS Users</label>
                            <input
                              type='text'
                              onChange={(e) => setIosPercentage(e.target.value)}
                              defaultValue={
                                totalPercentage.ios && totalPercentage.ios
                              }
                            />
                          </li>
                          {errorMessage && (
                            <span className='fm_error' style={{ color: 'red' }}>
                              {errorMessage}
                            </span>
                          )}
                          <div className='button-wrap mt-3'>
                            <button
                              className='btn btn-primary'
                              type='button'
                              onClick={() => handlePhonePercentages()}>
                              Save
                            </button>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='card settings-account-details'>
                    <div className='card-header'>
                      <h2>App info</h2>
                    </div>
                    <div className='card-body'>
                      <div className='settings-list-wrapper'>
                        <ul>
                          <li>
                            <label htmlFor=''>Verison: </label>
                            <SwitchServer>
                              {({ handleSwitchServer }) => (
                                <span
                                  onClick={handleSwitchServer}
                                  style={{ fontWeight: 600 }}
                                  className='fs-6'>
                                  {APP_VERSION}
                                </span>
                              )}
                            </SwitchServer>
                          </li>
                          <li>
                            <label htmlFor=''>Update at: </label>
                            <span style={{ fontWeight: 600 }} className='fs-6'>
                              {BUILD_DATE_TIMESTAMP}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <FooterEnd />
    </div>
  );
};

const mapStateToProps = ({
  authReducer: { user, tenant },
  percentageReducer: { totalPercentage },
}) => ({
  tenantId: user.tenantId,
  user: user,
  tenant: tenant,
  totalPercentage: totalPercentage,
});

const mapDispatchToProps = (dispatch) => ({
  setTenant: (data) => dispatch(setTenant(data)),
  setCallPercentage: (data) => dispatch(setCallPercentage(data)),
  showToast: (data) => dispatch(showToast(data)),
  setLocation: (data) => dispatch(setLocation(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
